import Vue from 'vue';
import Router from 'vue-router';
import { isHttps } from '@/util/const.js'
Vue.use(Router);

const routes = [
  { path: '/',redirect: {name:"home"}},
  {
    path: '/', name: 'home',
    component: () => import('@/views/NyHome.vue')
  },
  // { path: '',redirect: {name:"home"}},
  // {
  //   path: '/', name: 'home',
  //   component: () => import('@/views/NyHome.vue')
  // },
  {
    path: '/model', name: 'model',
    component: () => import('@/views/ModelScheme.vue')
  },
  {
    path: '/native', name: 'native',
    component: () => import('@/views/NativeApplication.vue')
  },
  {
    path: '/industry', name: 'industry',
    component: () => import('@/views/IndustryModel.vue')
  },
  {
    path: '/solution', name: 'solution',
    component: () => import('@/views/Solution.vue')
  },
  {
   path: "/protocol/:index", name: 'protocol',
   component: () => import('@/views/Protocol.vue')
  }
]

let router = new Router({
  routes: routes,
  mode: "history",
})
export default router;
